const reservationPaths = {
  SEARCH_RESERVATION: "search",
  RESERVATION_ID: (id) => id,
};

export default reservationPaths;
